export enum Component {
  Undefined = 0,
  Button = 1,
  Icon = 2,
  DropDown = 3,
  ComboBox = 4
}

export enum HtmlPaneType {
  Undefined = 0,
  Left = 1,
  Right = 2
}

export enum Orientation {
  Undefined = 0,
  Horizontal = 1,
  Vertical = 2
}

export enum DragDirection {
  Undefined = 0,
  Top = 1,
  Left = 2,
  Bottom = 3,
  Right = 4
}

export enum Axis {
  Undefined = 0,
  X = 1,
  Y = 2
}

export enum IconShape {
  Default = 0,
  Round
}

export enum IconType {
  Kendo = 0,
  Material
}

export enum WindowState {
  Open = 1,
  Closed
}

export enum TimeLineType {
  Rig = 0,
  FracGroup = 1,
  SpudderRig = 3,
  Rresource = 4
}

export enum ScheduleType {
  Rig = 0,
  FracGroup = 1,
  SpudderRig = 3,
  Resource = 4
}

export enum ResourceType {
  Undefined = 0,
  FracFleet = 4,
  SpudderRig = 3,
  IntermediateRig = 2,
  TotalDepth = 1
}

export enum EventType {
  Undefined = 0,
  Show = 1,
  Hide = 2,
  Enable = 3,
  Disable = 4,
  Active = 5,
  InActive = 6,
  Request = 7,
  Response = 8,
  AckNotledged = 9,
  OnChange = 10,
  OnDragDrop = 11,
  Remove = 12,
  Clear = 13
}

export default {
  Axis,
  Component,
  DragDirection,
  EventType,
  HtmlPaneType,
  IconShape,
  Orientation,
  ResourceType,
  ScheduleType,
  TimeLineType,
  WindowState,
};

export const skipProjectColumn: string[] = [
  "Project Tech",
  "Project Controls Analyst",
  "Project Engineer",
  "Project Team",
  "Project Manager",
  "Program Manager"
];